import {
  type ValidRequestData,
  type ValidFormData,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";
import React, { type CSSProperties } from "react";
import type { FieldValues } from "react-hook-form";

import { DevTool } from "@hookform/devtools";

import { ResourceFormApiContext } from "src/components/Form/ResourceFormApiContext.tsx";
import { FormProvider as ReactHookFormFormProvider } from "react-hook-form";
import { ResourceFormContext } from "src/components/Form/ResourceFormContext.tsx";

import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

import type { ValidParams } from "src/lib/react-router/types.ts";
import {
  useResourceForm,
  type UseResourceFormProps,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { ResourceFormLayout } from "src/components/Form/ResourceFormLayout.tsx";

export type ResourceFormProps = UseResourceFormProps & {
  className?: string;
  style?: CSSProperties;
};

await loadTranslations(TranslationNamespaceEnum.FormComponent);

export const ResourceForm = <
  FormValues extends FieldValues = FieldValues,
  Params extends ValidParams = ValidParams,
  FormData extends ValidFormData = ValidFormData,
  RequestData extends ValidRequestData = ValidRequestData,
>(
  props: ResourceFormProps,
) => {
  const { style, className, ...restProps } = props;

  const { formContext, formApi, form, layout } = useResourceForm<
    FormValues,
    Params,
    FormData,
    RequestData
  >(restProps);

  // const previousFormContext = useRef<any>(null);
  // const previousFormApi = useRef<any>(null);
  // const previousLayoutRef = useRef<any>(null);
  //
  // useEffect(() => {
  //   previousFormContext.current = formContext;
  //   previousFormApi.current = formApi;
  //   previousLayoutRef.current = layout;
  // });
  //
  // if (
  //   previousLayoutRef.current != null &&
  //   previousLayoutRef.current !== layout
  // ) {
  //   logger.debug("layout reference changed");
  // }
  //
  // if (
  //   previousFormContext.current != null &&
  //   previousFormContext.current !== formContext
  // ) {
  //   logger.debug("form context reference changed");
  // }
  //
  // if (previousFormApi.current != null && previousFormApi.current !== formApi) {
  //   logger.debug("form api content reference changed");
  // }

  return (
    <ResourceFormContext.Provider value={formContext}>
      <ResourceFormApiContext.Provider value={formApi}>
        <ReactHookFormFormProvider {...form}>
          <ResourceFormLayout
            config={layout}
            style={style}
            className={className}
          />

          {import.meta.env.DEV && <DevTool control={form.control} />}
        </ReactHookFormFormProvider>
      </ResourceFormApiContext.Provider>
    </ResourceFormContext.Provider>
  );
};
